import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Percent } from "lucide-react";
import { Field } from "../../../components/neu/Field";
import { NeuDropdown } from "../../../components/data/NeuDropdown";
import { NeuButton } from "../../../components/neu/Neu";
import { listCurrencies, listStandards } from "../../../api/gl";
import { localName } from "../../../lib/localName";

// تبويب النظام المحاسبي: يحدد قالب دليل الحسابات + العملة + الضريبة لكل فرع.
export const AccountingTab = ({ form, set }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const [meta, setMeta] = useState({ standards: [], currencies: [] });

  useEffect(() => {
    Promise.all([listStandards(), listCurrencies()])
      .then(([std, cur]) => setMeta({ standards: std.items || [], currencies: cur.items || [] }))
      .catch(() => setMeta({ standards: [], currencies: [] }));
  }, []);

  const pickStandard = (code) => {
    const std = meta.standards.find((row) => row.code === code);
    set("accounting_standard", code);
    if (std) {
      set("primary_currency", std.currency_default);
      set("vat_enabled", !!std.vat_enabled);
      set("vat_rate", std.vat_default_rate || 0);
    }
  };

  return (
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2 rounded-2xl bg-primary/5 p-4 shadow-neu-in">
        <p className="text-sm font-bold">{t("branches.accounting.title")}</p>
        <p className="mt-1 text-xs text-muted-foreground">{t("branches.accounting.hint")}</p>
      </div>
      <div>
        <p className="label-xs mb-2">{t("branches.accounting.standard")}</p>
        <NeuDropdown testid="branch-accounting-standard" value={form.accounting_standard || "IFRS"}
                     onChange={pickStandard}
                     options={meta.standards.map((row) => ({
                       value: row.code, label: localName(row) }))} />
      </div>
      <div>
        <p className="label-xs mb-2">{t("branches.accounting.currency")}</p>
        <NeuDropdown testid="branch-primary-currency" value={form.primary_currency || "USD"}
                     onChange={(v) => set("primary_currency", v)}
                     options={meta.currencies.map((row) => ({
                       value: row.code,
                       label: `${row.code} — ${localName(row)} (${row.symbol})` }))} />
      </div>
      <Field label={t("branches.accounting.vatRate")} testId="branch-vat-rate"
             value={form.vat_rate ?? 0} onChange={(v) => set("vat_rate", Number(v) || 0)} type="number"
             accent="emerald" icon={Percent} />
      <div>
        <p className="label-xs mb-2">{t("branches.accounting.vatEnabled")}</p>
        <NeuButton type="button" data-testid="branch-vat-toggle"
                   className={`px-4 py-2 ${form.vat_enabled ? "text-primary shadow-neu-in" : ""}`}
                   onClick={() => set("vat_enabled", !form.vat_enabled)}>
          {form.vat_enabled ? t("app.yes") : t("app.no")}
        </NeuButton>
      </div>
      <p className="sm:col-span-2 text-[11px] text-muted-foreground">
        💡 {t("branches.accounting.autoClone")}
      </p>
    </div>
  );
};
